export default __webpack_public_path__ + "static/media/BP.99894605.png";